import React from "react";
import {
    Menu,
    MenuItem,
    Checkbox,
    FormControlLabel,
    withStyles,
} from "@material-ui/core";
import withMetadataGridMultiSelectCheckbox from "../hocs/withMetadataGridMultiSelectCheckbox";

const BlueCheckbox = withStyles({
    root: {
        color: "#005CC8",
        "&$checked": {
            color: "#005CC8",
        },
    },
    checked: {},
})(Checkbox);

const MultiSelectCheckbox = ({
    toggleCheckbox,
    anchorEl,
    handleClose,
    renderAllOption,
    isOptionChecked,
    ...props
}) => {
    return (
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            style={{ marginTop: "-2px" }}
        >
            {renderAllOption && renderAllOption()}
            {(props.values ?? []).map((option) => {
                return (
                    <MenuItem
                        key={option.id}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <FormControlLabel
                            control={
                                <BlueCheckbox
                                    checked={isOptionChecked(option)}
                                    onChange={() => toggleCheckbox(option)}
                                />
                            }
                            label={option.label || option.name}
                        />
                    </MenuItem>
                );
            })}
        </Menu>
    );
};

export default MultiSelectCheckbox;
